import React, { Component } from "react"

import {savingStatus} from '../../variables/ComboValues'
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF } from '../../elements/FormFields'

//import { digmaDate, searchTableFilter } from "./Utils.js"
//import { EditableCell } from "../TableList/EditableCell"

// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB
export const  Savings_microLegend = {
    "do_u_save": "האם אתם חוסכים?",
    "monthly_savings_avg": "חסכון ממוצע בחודש",
    "saving4each_child_sum": "כמה אתם חוסכים עבור הילדים ב''חסכון לכל ילד''?",
    "savings_comment": "הערות"
}

export class FamilySavings extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)

    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      //console.log("Family general this.state.products=", this.state.products)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            headerColumns = {[ "do_u_save", "monthly_savings_avg", "saving4each_child_sum", "savings_comment"]}
            tableTitle = {tableTitle} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      var buttonStyle = {marginRight: '0'}
      // console.log("General - products", products)
     
      var product = ""
      var cellData = []
      if (typeof products !== "undefined"){
          product = products
          cellData=[{
            type: "select",
            options: savingStatus, // ["לא","לפעמים","כל חדש בקביעות","אחר"],
            name: "do_u_save",
            value: product.do_u_save,
            id: product.id,
            style: {width: "160px", verticalAlign: 'top'},
            edit: true
          },{
            type: "text",
            name: "monthly_savings_avg",
            value: product.monthly_savings_avg,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "saving4each_child_sum",
            value: product.saving4each_child_sum,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "textarea",
            name: "savings_comment",
            value: product.savings_comment,
            id: product.id,
            style: {width: "300px"},
            edit: true
          }]  

      }
      return (
        <div className="yahav-modal" style={{minHeight :'300px'}} >
            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left update-button" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform width1140" >
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    />
            </div>
            <ul><li>בחסכון לילדים יש לספק סכום החסכון *של כל* הילדים</li></ul>
        </div>
      )
    }
  }

class ProductRow extends Component {
    
    render() {
      const {onProductTableUpdate, cd} = this.props
      var key = 0;
      if (cd === "undefined" || !cd.length)
        return (<h4>קבוצת השדות לא מוגדרות במאגר המידע<br/>כנראה בעיה במעבר מאינטייק למשפחה</h4>)
    //console.log("ProductRow = cd=", cd)
      return (
        <div className="eachRow" >
          {cd.map(cellInfo => {
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} cellData={cellInfo} /> )
          })}
  
        </div>
      )
  
    }
  
  }
  
  class EditableFormCell extends Component {
    render() {
        const tp = this.props
        const tpc = tp.cellData
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{Savings_microLegend[tpc.name]}</label><br />
              <select style={tpc.style} name={tpc.name} id={tpc.id} value={tpc.value} onChange={tp.onProductTableUpdate} > 
                <option key={1111111} value="נא לבחור" > נא לבחור </option>
                { tpc.options.map( item => <option key={item} value={item}>{item}</option>) }
              </select>
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{Savings_microLegend[tpc.name]}</label><br />
              <TextareaF tp={tp} tpc={tpc} />
            </div>
          )
        }
        return (
          <div className="form-cell-box-inline">
            <label  htmlFor={tpc.id}>{Savings_microLegend[tpc.name]}</label><br />
            <InputF tp={tp} tpc={tpc} />
          </div>
        )
  
    }
  }
